import { formatProductCardTag } from "@/lib/formatProductCardTag";

export function formatProductCardCategoryTag(value) {
  if (!value) return value;

  if (value === "human-medicine") return "Human";
  if (value === "veterinary-medicine") return "Veterinary";

  return formatProductCardTag(value);
}
